import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import momentTz from 'moment-timezone';
import { catchError, tap } from 'rxjs/operators';
import { IExpert } from '../../../../../../shared/models/expert.interface';
import { NotificationService } from '../../../../../../shared/services/notification.service';
import { getTimezoneAbbr } from '../../../../../../shared/utils/timezone.utils';

@Component({
  selector: 'app-expert-no-show-dialog',
  templateUrl: './expert-no-show-dialog.component.html',
  styleUrls: ['./expert-no-show-dialog.component.scss'],
  animations: [
    trigger('fade', [
      state(
        'a',
        style({
          opacity: 0,
        })
      ),
      state(
        'b',
        style({
          opacity: 1,
        })
      ),
      transition('a => b', animate('400ms ease-in')),
      transition('b => a', animate('400ms ease-out')),
    ]),
  ],
  standalone: false,
})
export class ExpertNoShowDialogComponent {
  public stage: 'confirmation' | 'loading' | 'completed' | 'error' =
    'confirmation';
  public officeHours = {
    start: momentTz().tz('Europe/London').hours(9).minutes(0),
    end: momentTz().tz('America/Chicago').hours(17).minutes(0),
  };

  get timezoneAbbr(): string {
    return getTimezoneAbbr(this.data.timezone);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { expert: IExpert; timezone: string },
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<ExpertNoShowDialogComponent>,
    public dialog: MatDialog
  ) {}

  public sendRequest(): void {
    this.stage = 'loading';
    this.notificationService
      .expertNoShow(this.data.expert.expertId)
      .pipe(
        tap(() => (this.stage = 'completed')),
        catchError(() => (this.stage = 'error'))
      )
      .subscribe();
  }
}
